import Mapbox from "./Mapbox";
//import Analytics from "./Analytics";
import flatpickr from "flatpickr";
import {flatpickrSpanish} from "flatpickr/dist/l10n/es";

flatpickr.localize(flatpickrSpanish);
window.flatpickr = flatpickr;

//window.segment = new Analytics();
window.Mapbox = new Mapbox(import.meta.env.VITE_RADAR_PUBLISHABLE_KEY);
window.Mapbox2 = new Mapbox(import.meta.env.VITE_RADAR_PUBLISHABLE_KEY);

window.addEventListener("segment.track", (e) => {
    const event = e.detail || e;
    segment.track(event.name, event.payload || {});
});
window.addEventListener("segment.identify", (e) => {
    const event = e.detail || e;
    segment.identify(event.userId, event.payload || {});
});


// Comentar/descomentar segun corresponda (Segment o Rudderstack)
// import { AnalyticsBrowser } from '@segment/analytics-next'
// window.segment = AnalyticsBrowser.load({ writeKey: import.meta.env.VITE_SEGMENT_SOURCE })

import * as AnalyticsBrowser from "rudder-sdk-js";
AnalyticsBrowser.load(import.meta.env.VITE_SEGMENT_SOURCE, "https://assetplanmtvj.dataplane.rudderstack.com");

window.segment = AnalyticsBrowser;
